export const GET_SALDO_REQUEST = "GET_SALDO_REQUEST";
export const GET_SALDO_SUCCESS = "GET_SALDO_SUCCESS";
export const GET_SALDO_FAIL = "GET_SALDO_FAIL";

export const SALDO_ADD_REQUEST = "SALDO_ADD_REQUEST";
export const SALDO_ADD_SUCCESS = "SALDO_ADD_SUCCESS";
export const SALDO_ADD_FAIL = "SALDO_ADD_FAIL";
